import { traceCar } from "./contour"
import type { FrameRequest, FrameResult } from "./vision-protocol"
import type { VisionEngine } from "./vision-engine"

// One look at the live camera with the engine: find the car, trace it if
// asked, check the corner if asked. Shared by the worker and the on-page
// fallback, so both answer exactly alike. Closes the pictures it's given.
export function runFrame(engine: VisionEngine, req: FrameRequest): FrameResult {
  try {
    const detections = engine.detect(req.detect, req.t)
    let outline: Float32Array | null = null
    if (req.segment) {
      const mask = engine.segment(req.segment.image, req.segment.point)
      outline = mask ? traceCar(mask.mask, mask.width, mask.height, req.segment.hint) : null
    }
    const view = req.view ? (engine.readFrame(req.view)?.probs ?? null) : null
    return { t: req.t, detections, outline, traced: !!req.segment, view, ms: engine.timings() }
  } finally {
    req.detect.close()
    req.segment?.image.close()
    req.view?.close()
  }
}
